<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5 textLight--text px-4 px-md-2 mouse-cursor"
    >
      <v-row align="center" class="pa-3 pa-md-0">
        <v-col cols="1" sm="1" md="1" class="text-start ps-md-7">
          <v-checkbox
            :input-value="isSelected"
            @change="$emit('onChange', $event)"
          />
        </v-col>

        <v-col cols="11" sm="5" md>
          <div class="text-ellipse-2 text-start">
            {{
              data.organization
                ? getLocalisedValue(data.organization.name)
                : "-"
            }}
          </div>
        </v-col>

        <v-col cols="12" sm="6" md>
          <div class="text-ellipse-2 text-start">
            <span>
              {{
                data.user
                  ? `${data.user.firstName || ""} ${data.user.lastName || ""}`
                  : "-"
              }}
            </span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <div class="text-ellipse-2 text-start">
            {{
              data.user && data.user.phone && data.user.phone.number
                ? data.user.phone.number
                : "-"
            }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "EmployeeProfilesTableRow",
  props: {
    data: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
